import Intro from "@/assets/images/login/intro2x_pre.png";

export default function LoginLogo() {
    return (
        <div className="text-sm flex-none h-[645px] w-[360px]  box-border max-lg:hidden">
            <img src={Intro} width="100%" height="100%"></img>
        </div>

    )
}